export default "__VITE_ASSET__f223f87c__"